import { createContext, useContext } from 'react';

type TTimelineSectionContext = {
  section: TimelineSection;
  isDontPlay?: boolean;
  isHeadLine?: boolean;
};

export const TimelineSectionContext = createContext<TTimelineSectionContext>(undefined!);

export const useTimelineSection = () => useContext(TimelineSectionContext);
